import React, { Component } from "react"
import request from "superagent"
import { Formik, Field, Form } from "formik"
import fieldStatus from "helpers/fieldStatus"
import NumberField from "components/NumberField"
import Dropzone from "react-dropzone"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import settings from "settings"
import { connect } from "react-redux"
import DateField from "components/DateField"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import ReactSelect from "components/ReactSelect"
import axios from "axios"
import HTMLEditor from "components/HTMLEditor"
import { toast } from "react-toastify"
import { GridContextProvider, GridDropZone, GridItem, swap } from "react-grid-dnd"
import _ from "lodash"

class WebsiteInfoModal extends Component {
	// Images really doesn't need to be in formik values, I think.
	constructor(props) {
		super(props)
		this.state = {
			images: [],
			data: {
				address: "",
			},
			fields: {
				marketing_price: "",
				marketing_description: "",
				classification: null,
				virtual: '',
				move_in_date: '',
				was_price: ''
			},
			image_type: null
		}
	}

	componentDidMount() {
		var userToken = localStorage.getItem("user")
		axios
			.post(settings.ep + "/getLotFull", this.props.data, {
				headers: { Authorization: `Bearer ${userToken}` },
			})
			.then((response) => {
				let f = {
					virtual: response.data.lot.virtual ? response.data.lot.virtual : null,
					was_price: response.data.lot.was_price ? response.data.lot.was_price : null,
					move_in_date: response.data.lot.move_in_date ? response.data.lot.move_in_date : null,
					classification: response.data.lot.classification ? response.data.lot.classification : null,
					marketing_price: response.data.lot.marketing_price ? response.data.lot.marketing_price : null,
					marketing_description: response.data.lot.marketing_description
						? response.data.lot.marketing_description
						: null,
				}

				this.setState({ fields: f, images: response.data.lot.images ? response.data.lot.images : [] }, () => {
					console.log(this.state)
				})
				this.props.loadingStatus(false)
			})
			.catch((error) => {
				// need error handling
				this.props.loadingStatus(false)
			})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	removeImage = (k, f) => {
		let images = _.clone(this.state.images)
		images.splice(k, 1)
		this.setState({ images })
		f.setFieldValue("images", images)
		let values = {
			files: images,
			type: "lot",
			id: this.props.data.id,
		}
		submitData("removeImage", values).then((data) => {
			toast.success(data.message)
		})
	}

	onImageDrop = (files, f) => {
		if (!this.state.image_type) {
			toast.error("Please select image type")
			return
		}
		const req = request.post(`${settings.ep}/inputHomeImage`)
		_.forEach(files, (r,k) => {
			req.attach(r.name, files[k])
		})
		//req.attach(files[0].name, files[0])
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.field(
			"attributes",
			JSON.stringify({
				lot_id: this.props.data.id,
				sale_id: this.props.data.sale_id,
				image_type: this.state.image_type,
			})
		)
		req.end((err, response) => {
			//return
			try {
				let resp = response.body

				if (err) {
					console.log(err)
				}
				if (resp.status == 200) {
					let state = _.cloneDeep(this.state)
					state.images = resp.data
					f.setFieldValue("images", resp.data)

					this.setState(state, () => {
						console.log(this.state)
					})
				}
			} catch (e) {
				console.error(e)
			}
		})
	}

	compileThumbs = (f) => {
		const arrayMove = require("array-move")
		const onChange = (sourceId, sourceIndex, targetIndex) => {
			//console.log(sourceId, sourceIndex, targetIndex)
			let images = _.clone(this.state.images)
			images = arrayMove(images, sourceIndex, targetIndex)
			this.setState({ images })
			f.values.images = images
		}
		let rows = Math.ceil(this.state.images.length / 4)
		let height = rows * 220
		return (
			<GridContextProvider onChange={onChange}>
				<GridDropZone
					id="items"
					boxesPerRow={4}
					rowHeight={200}
					style={{ height: `${height}px`, width: "100%" }}>
					{this.state.images.map((item, k) => {
						let url
						if (item?.url && item.url.includes("http")) {
							url = item.url
						} else {
							url = `${settings.s3}${item.url}`
						}
						// Parantheses in filename break image thumbnail
						url = decodeURI(url) // decding first because some url's are encoded already....% then gets to %25.
						url = encodeURI(url)
						url = url.replace(/\(/g, "%28").replace(/\)/g, "%29")
						let icon = (
							<div
								className="imageZone__thumb"
								key={`thumb` + item?.url}
								style={{
									backgroundImage: `url(${url})`,
								}}>
								<i
									className="fas fa-times-circle formFiles__removeIcon"
									onClick={() => this.removeImage(k, f)}></i>
							</div>
						)
						return (
							<GridItem key={item?.url} className="imageZone__block">
								<div
									style={{
										width: "100%",
										height: "100%",
										paddingBottom: "20px",
										paddingRight: "20px",
									}}>
									{icon}
								</div>
							</GridItem>
						)
					})}
				</GridDropZone>
			</GridContextProvider>
		)
	}

	formLayout = (f) => {
		return (
			<div>
				{console.log(f)}
				<Form>
					<ul className="modalForm__list">
						<li className={fieldStatus("marketing_price", f)}>
							<label htmlFor="marketing_price">Marketing Price</label>
							{f.errors.marketing_price && f.touched.marketing_price && (
								<div className="form__message">{f.errors.marketing_price}</div>
							)}
							<NumberField
								name="marketing_price"
								type="text"
								prefix={"$"}
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.marketing_price}
								error={f.errors.marketing_price}
								value={f.values.marketing_price}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("marketing_description", f)}>
							<label htmlFor="marketing_description">Marketing Description</label>
							{f.errors.marketing_description && f.touched.marketing_description && (
								<div className="form__message">{f.errors.marketing_description}</div>
							)}
							<HTMLEditor
								name={`marketing_description`}
								className="form__textarea"
								value={f.values.marketing_description}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
							/>
						</li>
						<li className={fieldStatus("virtual", f)}>
							<label htmlFor="virtual">Virtual Tour URL</label>
							{f.errors.virtual && f.touched.virtual && (
								<div className="form__message">{f.errors.virtual}</div>
							)}
							<Field name="virtual" className="form__input" type="text" />
						</li>
						<li className={fieldStatus("move_in_date", f)}>
							<label htmlFor="move_in_date">Estimated Move In Date</label>
							{f.errors.move_in_date && f.touched.move_in_date && (
								<div className="form__message">{f.errors.move_in_date}</div>
							)}
							<DateField
								name="move_in_date"
								value={f.values.move_in_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.move_in_date}
								error={f.errors.move_in_date}
							/>
						</li>
						<li className={fieldStatus("was_price", f)}>
							<label htmlFor="was_price">Was Price (if any)</label>
							{f.errors.was_price && f.touched.was_price && (
								<div className="form__message">{f.errors.was_price}</div>
							)}
							<NumberField
								name="was_price"
								type="text"
								prefix={"$"}
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.was_price}
								error={f.errors.was_price}
								value={f.values.was_price}
								thousandSeparator={true}
							/>
						</li>
						{this.props.payload.public?.lot_classifications?.length > 0 ? (
							<li className={fieldStatus("classification", f)}>
								<label htmlFor="classification">Classification</label>
								{f.errors.classification && f.touched.classification && (
									<div className="form__message">{f.errors.classification}</div>
								)}
								<ReactSelect
									key={`classification`}
									name={`classification`}
									options={_.map(this.props.payload.public.lot_classifications, (r) => {
										return { value: r.id, label: r.name }
									})}
									value={f.values.classification}
									onBlur={f.setFieldTouched}
									onChange={f.setFieldValue}
									isMulti
								/>
							</li>
						) : null}
						<li className="form__listItem form__listItem--imageZone !basis-full">
							<label htmlFor="home_comments">Home Images</label>
							<p className="mid infoNote py-2 m-0">
								<i className={`fas fa-info-circle`} />
								Before uploading images, please select a category. If no category is selected the type
								will be unknown.
							</p>
							<ReactSelect
								className="mb-2 mt-1 w-3/12"
								key={`image_type`}
								name={`image_type`}
								options={[
									{ value: "elevation", label: "Elevation" },
									{ value: "interior", label: "Interior" },
									{ value: "exterior", label: "Exterior" },
									{ value: "floorplan", label: "Floorplan" },
								]}
								value={this.state.image_type}
								onBlur={() => {}}
								onChange={(k, v) => {
									this.setState({ image_type: v })
								}}
							/>
							<div className="imageZone">
								<Dropzone
									multiple={true}
									onDrop={(files) => {
										this.onImageDrop(files, f)
									}}>
									{({ getRootProps, getInputProps }) => (
										<section className="dropzone">
											<div {...getRootProps()} className="dropbox__cont imageZone__cont">
												<input {...getInputProps()} />
												<p className="dropzone__action imageZone__action">
													Drag 'n' drop images here, or click to select images.
												</p>
											</div>
										</section>
									)}
								</Dropzone>
								<div className="imageZone__existing">
									<ul className="imageZone__list">{this.compileThumbs(f)}</ul>
								</div>
							</div>
						</li>
					</ul>
					<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	render() {
		return (
			<div className="modal">
				<h3>Website Info: {this.props.data.address}</h3>
				<p className="text-sm">
					Marketing price will be overwritten by your builder feed nightly, if available. If this price
					continually changes, please update your internal system to update pricing.
				</p>
				<Formik
					/* initialValues={{
						marketing_price: '',
						marketing_description: '',
						images: []
					}} */
					initialValues={this.state.fields}
					enableReinitialize
					onSubmit={(values) => {
						values.id = this.props.data.id
						values.action = "inputBuildersWebsiteInfo"
						if(values.classification) values.classification = JSON.stringify(values.classification)
						//delete values.images
						submitData("mainIngest", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
							})
					}}
					render={(f) => this.formLayout(f)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(WebsiteInfoModal)
